import { ArrowRightIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';
import { useContent } from '../context/ContentContext';

export default function FinancingTeaser() {
  const { content } = useContent();
  const ft = content.financingTeaser;

  return (
    <section id="financing" className="relative overflow-hidden" style={{ backgroundColor: '#111b21' }}>
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-96 h-96 bg-brand-orange/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-brand-orange/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-site mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 border border-brand-orange/30 rounded-lg px-4 py-2 mb-6">
              <span className="w-2 h-2 bg-brand-orange rounded-full" />
              <span className="text-brand-orange font-semibold text-sm uppercase tracking-wider">
                {ft.sectionLabel}
              </span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-[44px] font-serif font-bold text-white leading-[1.15] mb-4 sm:mb-6">
              {ft.heading}
            </h2>

            <p className="text-base sm:text-lg text-white/50 leading-relaxed max-w-lg mb-8">
              {ft.description}
            </p>

            <Link
              to="/financing"
              className="group inline-flex items-center justify-center gap-2.5 bg-brand-orange text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-brand-navy shadow-lg shadow-brand-orange/25 transition-all duration-300"
            >
              <span>{ft.buttonLabel}</span>
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {ft.highlights.map((item) => (
              <div
                key={item}
                className="flex items-start gap-3 bg-white/[0.03] border border-white/[0.06] rounded-xl p-4 sm:p-5"
              >
                <CheckCircleIcon className="w-5 h-5 text-brand-orange flex-shrink-0 mt-0.5" />
                <span className="text-white/80 text-sm sm:text-[15px] leading-snug font-medium">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
